import { z } from "zod";

export const tripsBuilderOdometerPayloadSchema = z.object({
  from: z.iso.datetime().optional(),
});

export type TripsBuilderOdometerPayload = z.infer<
  typeof tripsBuilderOdometerPayloadSchema
>;
